var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect } from "react";
import { BooleanInput, ReferenceInput, SaveButton, Toolbar, SelectInput, SimpleForm, TextInput, useGetList, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
var Hidden = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
var ReservedSpace = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-height: 40px;\n"], ["\n    min-height: 40px;\n"])));
var PullChecker = function (_a) {
    var id = _a.id, resource = _a.resource, dependencies = _a.dependencies, onResolved = _a.onResolved;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _b = useGetList(resource, { filter: { id: id } }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    }), data = _b.data, isLoading = _b.isLoading, error = _b.error;
    useEffect(function () {
        onResolved({ data: data, isLoading: isLoading, error: error });
    }, __spreadArray([isLoading, data, error, id], dependencies, true));
    return _jsx("div", {});
};
export var CreateElectionEventScreen = function () {
    var t = useTranslation().t;
    var _a = useCreateElectionEventStore(), postDefaultValues = _a.postDefaultValues, handleElectionCreated = _a.handleElectionCreated, handleSubmit = _a.handleSubmit, isLoading = _a.isLoading, newId = _a.newId, tenantId = _a.tenantId;
    return (_jsxs(_Fragment, { children: [newId && (_jsx(PullChecker, { id: newId, resource: "sequent_backend_election_event", dependencies: [isLoading, newId], onResolved: handleElectionCreated })), _jsxs(SimpleForm, { defaultValues: postDefaultValues, onSubmit: handleSubmit, toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { className: "election-event-save-button", disabled: isLoading }) }), children: [_jsx(ElectionHeaderStyles.Title, { children: t("createResource.electionEvent") }), _jsx(TextInput, { source: "name" }), _jsx(TextInput, { source: "description" }), _jsxs(Hidden, { children: [_jsx(SelectInput, { source: "encryption_protocol", choices: [{ id: "WBRAID", name: "wbraid" }], defaultValue: "WBRAID" }), _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "slug", defaultValue: tenantId }) }), _jsx(BooleanInput, { source: "is_archived", defaultValue: false }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: true,
                                    displayDataTypes: false,
                                } }), _jsx(JsonInput, { source: "presentation", jsonString: false, reactJsonOptions: {
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: true,
                                    displayDataTypes: false,
                                } }), _jsx(JsonInput, { source: "voting_channels", jsonString: false, reactJsonOptions: {
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: true,
                                    displayDataTypes: false,
                                } }), _jsx(JsonInput, { source: "voting_channels", jsonString: false, reactJsonOptions: {
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: true,
                                    displayDataTypes: false,
                                } }), _jsx(JsonInput, { source: "dates", jsonString: false, reactJsonOptions: {
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: true,
                                    displayDataTypes: false,
                                } }), _jsx(TextInput, { source: "user_boards" }), _jsx(TextInput, { source: "audit_election_event_id" })] }), _jsx(ReservedSpace, { children: isLoading ? _jsx(CircularProgress, {}) : null })] }), _jsx("hr", {})] }));
};
var templateObject_1, templateObject_2;
